export const domain = process.env.VUE_APP_API_IP; 
export const fixResult = ['Cross matching', 'Blood Parasite (BP)']
